import { Locale } from '../i18n';

export interface TitleBlockField {
  key: string;
  labelKey: string;
}

interface PerSiteConfig {
  appName: string;
  contactEmail: string;
  logoSrc: string;
  defaultLocale: Locale;
  termsUrl: string;
  titleBlockFields: TitleBlockField[];
  guideLinks: {
    scale: string;
    drawingTool: string;
    importBackground: string;
    overview: string;
    enableLocalStorage: string;
  };
}

const PER_SITE_CONFIGS: Record<string, PerSiteConfig> = {
  'ritabygglov.se': {
    appName: 'Ritabygglov',
    contactEmail: 'ritabygglov@gmail.com',
    logoSrc: '/logo.png',
    defaultLocale: 'sv',
    termsUrl: 'https://ritabygglov.se/anvandarvillkor',
    titleBlockFields: [
      { key: 'name', labelKey: 'titleBlock.fields.name' },
      { key: 'drawingHeadType', labelKey: 'titleBlock.fields.drawingType' },
      {
        key: 'drawingHeadPropertyReference',
        labelKey: 'titleBlock.fields.propertyReference',
      },
      { key: 'author', labelKey: 'titleBlock.fields.author' },
      { key: 'authorExportedAt', labelKey: 'titleBlock.fields.date' },
    ],
    guideLinks: {
      scale: 'https://ritabygglov.se/guide#stalla-in-ritningens-skala',
      drawingTool: 'https://ritabygglov.se/guide#rita-med-ritverktyget',
      importBackground: 'https://ritabygglov.se/guide#importera-underlag',
      overview: 'https://ritabygglov.se/guide',
      enableLocalStorage:
        'https://www.whatismybrowser.com/guides/how-to-enable-cookies/auto',
    },
  },
  'drawblueprint.com': {
    appName: 'Drawblueprint',
    contactEmail: 'ritabygglov@gmail.com',
    logoSrc: '/drawblueprint.png',
    defaultLocale: 'en',
    termsUrl: 'https://drawblueprint.com/terms',
    titleBlockFields: [
      { key: 'name', labelKey: 'titleBlock.fields.projectName' },
      { key: 'drawingHeadType', labelKey: 'titleBlock.fields.drawingType' },
      {
        key: 'drawingHeadPropertyReference',
        labelKey: 'titleBlock.fields.propertyDesignation',
      },
      { key: 'author', labelKey: 'titleBlock.fields.yourName' },
      { key: 'authorExportedAt', labelKey: 'titleBlock.fields.date' },
    ],
    guideLinks: {
      scale: 'https://ritabygglov.se/guide#stalla-in-ritningens-skala',
      drawingTool: 'https://ritabygglov.se/guide#rita-med-ritverktyget',
      importBackground: 'https://ritabygglov.se/guide#importera-underlag',
      overview: 'https://ritabygglov.se/guide',
      enableLocalStorage:
        'https://www.whatismybrowser.com/guides/how-to-enable-cookies/auto',
    },
  },
};

const injected = window.__SITE_CONFIG__ ?? {
  site: 'ritabygglov',
  domain: 'ritabygglov.se',
  appDomain: 'app.ritabygglov.se',
};

const perSite =
  PER_SITE_CONFIGS[injected.domain] ?? PER_SITE_CONFIGS['ritabygglov.se'];

export const siteConfig = {
  site: injected.site,
  domain: injected.domain,
  appDomain: injected.appDomain,
  ...perSite,
};
